import React from 'react';
import { TableProps } from 'tea-component';
import BaseMetricsTable, { IBaseMetricsTableCommonProps } from '../BaseTable';
import { getCommonSystemTerminologyColumns } from '../../utils/columns';

import type { IBaseProps } from '@home/types/common';
import type { IMetricsCommonSystemTerminology } from '@gp/types/metrics';

interface ICommonSystemTerminologyTableProps
  extends IBaseProps,
  Omit<TableProps, 'verticalTop' | 'addons' | 'columns' | 'recordKey' | 'records'>,
  IBaseMetricsTableCommonProps<IMetricsCommonSystemTerminology> {
  keyword?: string;
}

const CommonSystemTerminologyTable: React.FC<ICommonSystemTerminologyTableProps> = (props) => {
  const { keyword, ...restProps } = props;

  const columns = getCommonSystemTerminologyColumns({ keyword });

  return <BaseMetricsTable {...restProps} sortableKeys={['metric']} columns={columns} />;
};

export default CommonSystemTerminologyTable;
